// src/components/Login/panel/Dashboard.jsx

import React, {
  useEffect,
  useRef,
  useState,
  useMemo
} from "react";

import {
  useNavigate,
  Outlet,
  useParams,
  useLocation,
  matchPath
} from "react-router-dom";


import Sidebar from "./Sidebar";
import Inbox from "./Inbox";
import MessageDetail from "./MessageDetail";
import MessagePopup from "./MessagePopup";
import StatsCard from "./StatsCard";
import MainContent from "./MainContent";

import PersonalInfoForm from "../panel/maincontentpanel/PersonalInfoForm";
import CircularsSection from "./CircularsSection";
import NewsSection from "./NewsSection";
import StudentsTable from "./maincontentpanel/StudentsTable";
import ChangeCoachClubs from "./maincontentpanel/ChangeCoachClubs";
import ClubCoachesManagement from "./maincontentpanel/ClubCoachesManagement";
import CoachRequests from "./maincontentpanel/CoachRequests";

import HeyatCoachesTable from "./maincontentpanel/HeyatCoachesTable";
import HeyatRefereesTable from "./maincontentpanel/HeyatRefereesTable";
import HeyatClubsTable from "./maincontentpanel/HeyatClubsTable";
import HeyatCreateNews from "./maincontentpanel/HeyatCreateNews";

import MatchesSection from "./MatchesSection";
import SeminarsSection from "../seminar/SeminarsSection";

import "./dashboard.css";



const API_BASE =
  "https://api.chbtkd.ir";



// تشخیص نقش‌های باشگاه / هیئت
const isClubLike = (r) =>
  [
    "club",
    "heyat",
    "board"
  ]
  .includes(
    String(r || "").toLowerCase()
  );




const Dashboard = () => {


  const navigate = useNavigate();

  const location = useLocation();

  const {
    role: roleFromRoute
  } = useParams();



  const logoutTimerRef =
    useRef(null);




  const storedRole = useMemo(
    () =>
      (
        localStorage.getItem(
          "user_role"
        )
        ||
        "guest"
      )
      .toLowerCase(),

    []
  );





  const [role, setRole] =
    useState(null);


  const [selectedSection, setSelectedSection] =
    useState("matches");


  const [isMobile, setIsMobile] =
    useState(
      () =>
      window.innerWidth <= 768
    );


  const [showSidebar, setShowSidebar] =
    useState(
      () =>
      !(window.innerWidth <= 768)
    );



  // ===========================
  // پیام خوانده نشده
  // ===========================

  const [unreadMessages, setUnreadMessages] =
    useState(0);


  const [showMessagePopup, setShowMessagePopup] =
    useState(false);





  const inNestedView = useMemo(() => {


    const p =
      location.pathname;


    return Boolean(

      matchPath(
        "/dashboard/:role/competitions/:slug",
        p
      )

      ||

      matchPath(
        "/dashboard/:role/competitions/:slug/*",
        p
      )

      ||

      matchPath(
        "/dashboard/:role/competitions/:slug/register/*",
        p
      )

      ||

      matchPath(
        "/dashboard/:role/competitions/:slug/bracket",
        p
      )

      ||

      matchPath(
        "/dashboard/:role/competitions/:slug/results",
        p
      )

      ||

      matchPath(
        "/dashboard/:role/enrollments/:enrollmentId",
        p
      )

      ||

      matchPath(
        "/dashboard/:role/enrollments/:enrollmentId/*",
        p
      )

      ||

      matchPath(
        "/dashboard/:role/courses/:slug",
        p
      )

      ||

      matchPath(
        "/dashboard/:role/courses/:slug/*",
        p
      )

      ||

      matchPath(
        "/dashboard/:role/courses/:slug/register/*",
        p
      )

    );


  },[
    location.pathname
  ]);






  const logout = () => {


    const savedRole =
      localStorage.getItem(
        "user_role"
      );



    [
      "both_token",
      "player_token",
      "coach_token",
      "referee_token",
      "club_token",
      "heyat_token",
      "board_token",
      "access_token",

    ].forEach(
      key =>
      localStorage.removeItem(key)
    );



    if(savedRole){

      localStorage.removeItem(
        `${savedRole}_token`
      );


      localStorage.removeItem(
        "user_role"
      );

    }



    navigate(
      "/",
      {
        replace:true
      }
    );


  };






  const resetLogoutTimer = () => {


    if(
      logoutTimerRef.current
    )

      clearTimeout(
        logoutTimerRef.current
      );



    logoutTimerRef.current =
      setTimeout(
        logout,
        10 * 60 * 1000
      );


  };
    // بررسی پیام‌های خوانده نشده هنگام ورود
  useEffect(() => {

    if (!role)
      return;


    const token =
      localStorage.getItem(
        `${role}_token`
      );


    if (!token)
      return;



    fetch(
      `${API_BASE}/api/notifications/unread-count/`,
      {
        headers: {
          Authorization:
            `Bearer ${token}`
        }
      }
    )

    .then(res => res.json())

    .then(data => {


      if (data.count > 0) {


        setUnreadMessages(
          data.count
        );


        setShowMessagePopup(
          true
        );


      }


    })

    .catch(error => {

      console.error(
        "UNREAD_COUNT_ERROR",
        error
      );

    });


  }, [role]);







  // احراز هویت + همگام‌سازی نقش + ریسایز + تایمر inactivity
  useEffect(() => {

    const savedRole =
      localStorage.getItem(
        "user_role"
      );


    const token =
      savedRole &&
      localStorage.getItem(
        `${savedRole}_token`
      );



    if (
      !savedRole ||
      !token
    ) {

      navigate(
        "/",
        {
          replace:true
        }
      );

      return;

    }



    setRole(
      savedRole
    );



    if (
      roleFromRoute &&
      roleFromRoute !== savedRole
    ) {


      const suffix =
        location.pathname.replace(
          /^\/dashboard\/[^/]+/,
          ""
        );



      navigate(
        `/dashboard/${encodeURIComponent(savedRole)}${suffix}${location.search}`,
        {
          replace:true
        }
      );


      return;

    }




    const handleResize = () => {


      const nowMobile =
        window.innerWidth <= 768;


      setIsMobile(
        nowMobile
      );


      setShowSidebar(
        !nowMobile
      );


    };




    window.addEventListener(
      "resize",
      handleResize
    );



    const events = [
      "mousemove",
      "keydown",
      "click",
      "scroll",
      "touchstart",
      "touchmove"
    ];



    events.forEach(
      event =>
      window.addEventListener(
        event,
        resetLogoutTimer
      )
    );



    resetLogoutTimer();



    return () => {


      window.removeEventListener(
        "resize",
        handleResize
      );



      events.forEach(
        event =>
        window.removeEventListener(
          event,
          resetLogoutTimer
        )
      );



      clearTimeout(
        logoutTimerRef.current
      );


    };


    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [
    navigate,
    roleFromRoute
  ]);







  // سینک بخش انتخابی با querystring
  useEffect(() => {

    if (inNestedView)
      return;


    const qs =
      new URLSearchParams(
        location.search
      );


    const sec =
      qs.get("section")
      ||
      "matches";


    setSelectedSection(
      sec
    );


  }, [
    location.search,
    inNestedView
  ]);






  if (!role)
    return null;






  const renderContent = () => {

    switch(selectedSection) {


      case "profile":

        return (
          <PersonalInfoForm
            role={role}
          />
        );



      case "messages":

        return (
          <Inbox
            role={role}
          />
        );



      case "message-detail":

        return (
          <MessageDetail />
        );



      case "circulars":

        return (
          <CircularsSection
            role={role}
          />
        );



      case "news":

        return (
          <NewsSection
            role={role}
          />
        );



      case "matches":

        return (
          <MatchesSection
            role={role}
          />
        );



      case "students":

        return (
          <StudentsTable
            role={role}
          />
        );



      case "club-change":

        return (
          <ChangeCoachClubs
            role={role}
          />
        );



      case "club-students":

        return (
          <StudentsTable
            role={role}
            view="club"
          />
        );



      case "club-coaches":

        return (
          <ClubCoachesManagement
            role={role}
          />
        );



      case "club-requests":

        return (
          <CoachRequests
            role={role}
          />
        );



      case "heyat-coaches":

        return (
          <HeyatCoachesTable
            role={role}
          />
        );



      case "heyat-referees":

        return (
          <HeyatRefereesTable
            role={role}
          />
        );



      case "heyat-clubs":

        return (
          <HeyatClubsTable
            role={role}
          />
        );



      case "heyat-create-news":

        return (
          <HeyatCreateNews
            role={role}
          />
        );



      case "courses":

        return (
          <SeminarsSection
            role={role}
          />
        );



      default:

        return (
          <MainContent
            role={role}
            selectedSection={selectedSection}
          />
        );

    }

  };





  const handleSectionSelect = (key) => {


    setSelectedSection(
      key
    );



    const r =
      (
        localStorage.getItem(
          "user_role"
        )
        ||
        role
        ||
        storedRole
      );



    navigate(
      `/dashboard/${encodeURIComponent(r)}?section=${encodeURIComponent(key)}`
    );


  };


    return (

    <>

      {
        showMessagePopup &&

        <MessagePopup

          count={unreadMessages}


          onOpen={() => {


            setShowMessagePopup(
              false
            );


            navigate(
              `/dashboard/${role}?section=messages`
            );


          }}



          onClose={() => {


            setShowMessagePopup(
              false
            );


          }}


        />

      }





      <div className="dashboard-container">


        {isMobile && (


          <button

            className="toggle-sidebar-btn"

            onClick={() =>
              setShowSidebar(
                prev => !prev
              )
            }


            aria-label={
              showSidebar
              ?
              "بستن منو"
              :
              "نمایش منو"
            }

          >


            {
              showSidebar
              ?
              "بستن منو"
              :
              "نمایش منو"
            }


          </button>


        )}





        <Sidebar

          className={
            isMobile
            ?
            (
              showSidebar
              ?
              "show"
              :
              ""
            )
            :
            ""
          }


          onLogout={
            logout
          }


          onSectionSelect={
            handleSectionSelect
          }


          selectedSection={
            selectedSection
          }


          role={
            role
          }


          isClubLike={
            isClubLike(role)
          }


        />





        <div className="dashboard-main">



          {
            !isMobile &&
            !inNestedView &&
            <StatsCard
              role={role}
            />
          }






          {
            inNestedView

            ?

            <Outlet

              context={{
                role,
                isClubLike:
                isClubLike(role)
              }}

              key={
                location.pathname
              }

            />


            :

            renderContent()

          }



        </div>




      </div>



    </>

  );


};


export default Dashboard;